// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import { initialize } from 'redux-form'
import { loadingToggler } from 'redux/modules/loading'
import { errorErrorsList } from 'redux/modules/notifications'
import { goBack } from 'react-router-redux'
import formatFilterForForm from './formatFilterForForm'
import getMaxBuckRadius from './getMaxBuckRadius'

import {
  AFS_GRID_FILTER,
  AFS_RESULTS_FILTER,
} from 'redux/modules/interferenceAnalysis/constants'

import {
  assembleQuery,
  fetchProjectAFSFilters,
} from 'helpers/api'

const initializeAFSResultsFilter = () => (dispatch, getState) => (
  dispatch(loadingToggler(
    async () => {
      const {
        form,
        projectSummary,
      } = getState()

      // figure out what band and analysis type are set in AFS_GRID_FILTER
      const gridFilterValues = form?.[AFS_GRID_FILTER]?.values || null

      const projectId = projectSummary.get('projectId')

      try {
        // the AFS Results Filter form represents a Results Filter configuration
        // for a given project id && band id && analysis type id.
        // these values are managed in the AFS_RESULTS_FILTER form.
        // if it is not yet ready, then the user has manually tried to access this page.
        // NOTE - we're only checking for the form here because in initializeInterferenceAnalysis
        // it is initialized after loadAnalysisSettings.
        // but to be clear, we also need the analysis settings to be loaded for
        // the AFS Results Filter form to work properly.
        if (gridFilterValues === null) {
          throw new Error('AFS Results Filter cannot load before AFS Grid.')
        }

        // take the analysis type and band that are assigned to AFS_GRID_FILTER
        // and use those to define exactly which AFS Results Filter the user should be seeing.
        const {
          analysisTypeId,
          bandId,
        } = gridFilterValues

        const query = assembleQuery([{
          field: 'analysisTypeId',
          value: analysisTypeId,
        }, {
          field: 'bandId',
          value: bandId,
        }])

        const { entity } = await fetchProjectAFSFilters(projectId, query)

        const {
          // for Display in the page component.
          analysisType,
          band,
        } = entity

        const maxBuckRadius = await getMaxBuckRadius(bandId)

        // initial values for the AFS Results Filter form
        // these values will ALWAYS come from API.
        const initialValues = formatFilterForForm(entity)

        await dispatch(initialize(AFS_RESULTS_FILTER, {
          ...initialValues,
          maxBuckRadius,
        }))

        // these values are held in the page component and used for display.
        return {
          analysisType,
          band,
        }
      } catch (err) {
        dispatch(errorErrorsList(err))
        dispatch(goBack())
        throw err
      }
    })
  )
)

export default initializeAFSResultsFilter
